import React from 'react';
import { PackFan } from '../PackFan';
import { CtaButton } from '../CtaButton';
import { scrollToOffer } from '../../utils/scroll';
export function Hero() {
  return <header className="w-full pt-28 pb-16 sm:pb-20 px-5 text-crema overflow-visible" style={{
    background: 'linear-gradient(180deg, #4A3A5C 0%, #332841 100%)'
  }} data-id="element-162" data-mp="7ykygubngc2g">
      <div className="max-w-4xl mx-auto flex flex-col items-center text-center overflow-visible" data-id="element-163" data-mp="hw8xhwgag5qf">
        <h1 className="font-serif text-4xl sm:text-5xl md:text-6xl font-bold leading-[1.1]" data-id="element-164" data-mp="mtsbcv92qghu">
          La letra de tu hijo se arregla{' '}
          <span className="text-coral" data-id="element-165" data-mp="vmm0rli8iw9f">en 21 días</span>, con 15 minutos por día
        </h1>

        <p className="mt-6 text-xl sm:text-2xl leading-relaxed text-crema/85 max-w-3xl" data-id="element-166" data-mp="10l5s61fll096">
          Si la maestra no le entiende lo que escribe, no es pereza: es un movimiento que nunca se
          entrenó. Acá está el plan, día por día.
        </p>

        <div className="w-full max-w-4xl mt-10 sm:mt-12 overflow-visible" data-id="element-167" data-mp="1ak4oqln395ft">
          <PackFan onClick={scrollToOffer} data-id="element-168" data-mp="9oube3kpl7zm" />
        </div>

        <p className="mt-6 font-serif text-2xl sm:text-3xl font-semibold" data-id="element-169" data-mp="4optqa82e77t">6 tomos + 6 bonos</p>
        <p className="mt-2 text-sm sm:text-base text-crema/70" data-id="element-170" data-mp="4r2jvanz7nvy">
          633 páginas · 400 actividades · 278 fichas para imprimir
        </p>

        <CtaButton action="scroll" size="lg" pulse className="mt-8" data-id="element-171" data-mp="3ruh4nmqx54mi">
          QUIERO EL KIT COMPLETO
        </CtaButton>
        <p className="mt-4 text-sm text-crema/70" data-id="element-172" data-mp="sdslwc0brigk">Acceso inmediato · Garantía de 14 días</p>
      </div>
    </header>;
}